import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import { FaSpinner } from 'react-icons/fa';
import Home from './pages/Home';
import About from './pages/About';
import Faq from './pages/Faq';
import Navbar from './pages/components/Navbar';
import WspButton from './pages/components/WspButton';
import Footer from './pages/components/Footer';
import DashBoardNonVerified from './pages/DashBoardNonVerified';
import AdminDashBoard from './pages/AdminDashboard';
import UserDashboard from './pages/UserDashboard';
import ViewPricing from './pages/ViewPricing';
import AddCoins from './pages/AddCoins';
import AddFunds from './pages/AddFunds';
import UserPaymentVerification from './pages/UserPaymentVerification';
import Widthdraw from './pages/Widthdraw';
import WidthrawlRequests from './pages/WidthrawlRequests';

const Loader = () => (
  <div style={{
    height: '100vh',
    width: '100%',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    position: 'fixed',
    top: 0,
    left: 0
  }}>
    <FaSpinner style={{
      fontSize: '3rem',
      color: '#275E76',
      animation: 'spin 1s linear infinite'
    }} />
    <style>{`
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

function AppContent() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const hiddenPaths = ['/thankyou', '/login', '/register', '/dash', '/admin-dashboard', '/user-dashboard', '/view-pricing', '/add-coins', '/add-funds', '/user-payment-verification', '/widthdraw', '/widthrawl-requests']; // add more paths here
const hideUI = hiddenPaths.includes(location.pathname);

  // Load listener on route change
  useEffect(() => {
    setIsLoading(true);

    // Wait for all assets to load
    const handleLoad = () => {
      setIsLoading(false);
    };

    if (document.readyState === 'complete') {
      setTimeout(handleLoad, 300); // slight delay to feel smooth
    } else {
      window.addEventListener('load', handleLoad);
      return () => window.removeEventListener('load', handleLoad);
    }
  }, [location.pathname]);
  return (
    <>
      {isLoading && <Loader />}
      {!isLoading && (
        <>
        {!hideUI && <Navbar />}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/dash" element={<DashBoardNonVerified />} />
            <Route path="/admin-dashboard" element={<AdminDashBoard />} />
            <Route path="/user-dashboard" element={<UserDashboard />} />
            <Route path="/view-pricing" element={<ViewPricing />} />
            <Route path="/add-coins" element={<AddCoins />} />
            <Route path="/add-funds" element={<AddFunds />} />
            <Route path="/user-payment-verification" element={<UserPaymentVerification />} />
            <Route path="/widthdraw" element={<Widthdraw />} />
            <Route path="/widthrawl-requests" element={<WidthrawlRequests />} />
          </Routes>
           {!hideUI && <Footer />}
        </>
      )}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
